import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledCalendarIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9971 3.5C20.3787 3.5 21.4994 4.61975 21.498 6.00195C21.4949 9.17646 21.4899 15.469 21.4961 19.9961C21.498 21.3792 20.3777 22.5004 18.9941 22.498C14.6271 22.4907 9.38463 22.4656 5.02051 22.4863C3.63287 22.4929 2.5 21.3715 2.5 19.9814V6C2.5 4.61929 3.61929 3.5 5 3.5H18.9971Z",
			fill: "white",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9971 3.5C20.3793 3.49994 21.4987 4.62163 21.499 6.00293C21.4991 6.52705 21.4998 7.02642 21.5 7.39453V8.5H2.5V6.00195C2.5 4.62037 3.62059 3.50029 5.00195 3.50098C9.66677 3.50337 14.3317 3.50075 18.9971 3.5Z",
			fill: "#4B7987",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 1.5V5.5",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 1.5V5.5",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 13H17.5",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 13H9.5",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 18H17.5",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 18H9.5",
			stroke: "#1F3B44",
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledCalendarIcon);
const Memo = memo(ForwardRef);
export default Memo;
